import { render, staticRenderFns } from "./PriceCalcTab.vue?vue&type=template&id=50d198f9&scoped=true&"
import script from "./PriceCalcTab.vue?vue&type=script&lang=js&"
export * from "./PriceCalcTab.vue?vue&type=script&lang=js&"
import style0 from "./PriceCalcTab.vue?vue&type=style&index=0&id=50d198f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d198f9",
  null
  
)

export default component.exports